import { classed } from "@tw-classed/core";
import type React from "react";
import type { ReactNode } from "react";
import type { ComponentColor } from "react-daisyui/dist/types";

export type LabelProps = Omit<React.LabelHTMLAttributes<HTMLLabelElement>, "color"> & {
  title?: string;
  children?: ReactNode;
  labelTextPosition?: "start" | "end";
  labelTextClassName?: string;
  color?: ComponentColor;
};

export const Label = ({
  children,
  title,
  labelTextPosition = "start",
  labelTextClassName,
  className,
  color,
  ...props
}: LabelProps) => {
  const isStartPosition = labelTextPosition === "start";
  const isEndPosition = labelTextPosition === "end";

  const classes = classed("label justify-start");
  const classesLabelText = classed(
    "label-text cursor-pointer",
    color ? `text-${color}` : "",
    isStartPosition && children ? "mr-2" : "",
    isEndPosition && children ? "ml-2" : "",
  );
  const labelText = <span className={classesLabelText({ className: labelTextClassName })}>{title}</span>;

  return (
    // biome-ignore lint/a11y/noLabelWithoutControl: children may contain associated form control
    <label className={classes({ className })} {...props}>
      {labelTextPosition === "start" && labelText}
      {children}
      {labelTextPosition === "end" && labelText}
    </label>
  );
};
